module.exports = __webpack_public_path__ + "static/media/2021km.078b9a2b.jpg";